import React from "react";
import { Link } from "react-router-dom";
import { renderImage } from "../../util/main";

export const MenuProfile = ({
  isUser,
  userRole,
  isAuth,
  handleLogout,
  onClose,
}) => {
  return (
    <div
      className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-[250px] bg-white/10 backdrop-blur-md border border-white/10 shadow-2xl z-40 rounded-xl overflow-hidden"
      onMouseLeave={onClose}
    >
      {isAuth ? (
        <div>
          <div className="relative bg-gradient-to-r from-blue-50/50 to-indigo-50/50 p-6 flex flex-col items-center border-b border-gray-100 shrink-0 transition-colors">
            <div className="w-[60px] h-[60px] rounded-full overflow-hidden mb-3 shadow-lg ring-4 ring-white bg-white flex items-center justify-center">
              {renderImage(isUser.fullname)}
            </div>

            <h2 className=" text-gray-800 tracking-tight font-rubik text-[25px] font-medium" >
              {isUser.username}
            </h2>
            <p className=" text-gray-500 font-rubik font-light text-[16px] leading-tight tracking-wide-5">{isUser.email}</p>
          </div>
          <Link
            to="/"
            className="flex px-4 py-2 hover:bg-gray-200/50 cursor-pointer transition-colors rounded-xl items-center justify-center"
            onClick={handleLogout}
          >
            Logout
          </Link>
        </div>
      ) : (
        <Link
          to="/login"
          className="flex px-4 py-2 hover:bg-gray-200/50 cursor-pointer transition-colors rounded-xl items-center justify-center"
        >
          Login
        </Link>
      )}
      {userRole === "admin" && (
        <Link
          to="/admin"
          className="flex px-4 py-2 hover:bg-gray-200/50 cursor-pointer transition-colors rounded-xl items-center justify-center"
        >
          Admin
        </Link>
      )}
    </div>
  );
};
